import { TokenUtils } from "../../utils/TokenUtils";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Token Values Area
export class AreaTokenValues {
    /** Creates a new theme with updated overrides */
    tokenThemeByUpdatingOverride(theme, override) {
        return TokenUtils.tokenThemeByUpdatingOverride(theme, override);
    }
    /** Creates a new theme with removed override */
    tokenThemeByRemovingOverride(theme, tokenId) {
        return TokenUtils.tokenThemeByRemovingOverride(theme, tokenId);
    }
    /** Creates a new color token with updated .color value */
    colorTokenByUpdatingColor(token, newValue) {
        return TokenUtils.colorTokenByUpdatingColor(token, newValue);
    }
    /** Creates a new color token with updated .opacity value */
    colorTokenByUpdatingOpacity(token, newValue) {
        return TokenUtils.colorTokenByUpdatingOpacity(token, newValue);
    }
    /** Creates a new blur token with updated .type value */
    blurTokenByUpdatingType(token, newValue) {
        return TokenUtils.blurTokenByUpdatingType(token, newValue);
    }
    /** Creates a new blur token with updated .radius value */
    blurTokenByUpdatingRadius(token, 
    // @ts-expect-error TS(2344): Type 'DimensionTokenValue' does not satisfy the co... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.blurTokenByUpdatingRadius(token, newValue);
    }
    /** Creates a new typography token with updated .fontFamily value */
    typographyTokenByUpdatingFontFamily(token, 
    // @ts-expect-error TS(2344): Type 'FontFamilyTokenValue' does not satisfy the c... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.typographyTokenByUpdatingFontFamily(token, newValue);
    }
    /** Creates a new typography token with updated .fontWeight value */
    typographyTokenByUpdatingFontWeight(token, 
    // @ts-expect-error TS(2344): Type 'FontWeightTokenValue' does not satisfy the c... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.typographyTokenByUpdatingFontWeight(token, newValue);
    }
    /** Creates a new typography token with updated .fontSize value */
    typographyTokenByUpdatingFontSize(token, 
    // @ts-expect-error TS(2344): Type 'FontSizeTokenValue' does not satisfy the con... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.typographyTokenByUpdatingFontSize(token, newValue);
    }
    /** Creates a new typography token with updated .letterSpacing value */
    typographyTokenByUpdatingLetterSpacing(token, 
    // @ts-expect-error TS(2344): Type 'LetterSpacingTokenValue' does not satisfy th... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.typographyTokenByUpdatingLetterSpacing(token, newValue);
    }
    /** Creates a new typography token with updated .lineHeight value */
    typographyTokenByUpdatingLineHeight(token, 
    // @ts-expect-error TS(2344): Type 'LineHeightTokenValue' does not satisfy the c... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.typographyTokenByUpdatingLineHeight(token, newValue);
    }
    /** Creates a new typography token with updated .paragraphSpacing value */
    typographyTokenByUpdatingParagraphSpacing(token, 
    // @ts-expect-error TS(2344): Type 'ParagraphSpacingTokenValue' does not satisfy... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.typographyTokenByUpdatingParagraphSpacing(token, newValue);
    }
    /** Creates a new typography token with updated .paragraphSpacing value */
    typographyTokenByUpdatingParagraphIndent(token, 
    // @ts-expect-error TS(2344): Type 'ParagraphSpacingTokenValue' does not satisfy... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.typographyTokenByUpdatingParagraphIndent(token, newValue);
    }
    /** Creates a new border token with updated .position value */
    typographyTokenByUpdatingTextDecoration(token, 
    // @ts-expect-error TS(2344): Type 'TextDecorationTokenValue' does not satisfy t... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.typographyTokenByUpdatingTextDecoration(token, newValue);
    }
    /** Creates a new typography token with updated .textCase value */
    typographyTokenByUpdatingTextCase(token, 
    // @ts-expect-error TS(2344): Type 'TextCaseTokenValue' does not satisfy the con... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.typographyTokenByUpdatingTextCase(token, newValue);
    }
    /** Creates a new border token with updated .color value. Do note, opacity is ignored */
    borderTokenByUpdatingColor(token, newValue) {
        return TokenUtils.borderTokenByUpdatingColor(token, newValue);
    }
    /** Creates a new border token with updated color.opacity value */
    borderTokenByUpdatingOpacity(token, newValue) {
        return TokenUtils.borderTokenByUpdatingOpacity(token, newValue);
    }
    /** Creates a new border token with updated .width value */
    borderTokenByUpdatingWidth(token, 
    // @ts-expect-error TS(2344): Type 'BorderWidthTokenValue' does not satisfy the ... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.borderTokenByUpdatingWidth(token, newValue);
    }
    /** Creates a new border token with updated .position value */
    borderTokenByUpdatingPosition(token, newValue) {
        return TokenUtils.borderTokenByUpdatingPosition(token, newValue);
    }
    /** Creates a new border token with updated .style value */
    borderTokenByUpdatingStyle(token, newValue) {
        return TokenUtils.borderTokenByUpdatingStyle(token, newValue);
    }
    /** Creates a new dimension token with updated value */
    dimensionTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'DimensionTokenValue' does not satisfy the co... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.dimensionTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new size token with updated value */
    sizeTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'SizeTokenValue' does not satisfy the constra... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.sizeTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new space token with updated value */
    spaceTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'SpaceTokenValue' does not satisfy the constr... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.spaceTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new opacity token with updated value */
    opacityTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'OpacityTokenValue' does not satisfy the cons... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.opacityTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new font size token with updated value */
    fontSizeTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'FontSizeTokenValue' does not satisfy the con... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.fontSizeTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new font size token with updated value */
    lineHeightTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'LineHeightTokenValue' does not satisfy the c... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.lineHeightTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new letter spacing token with updated value */
    letterSpacingTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'LetterSpacingTokenValue' does not satisfy th... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.letterSpacingTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new paragraph spacing token with updated value */
    paragraphSpacingTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'ParagraphSpacingTokenValue' does not satisfy... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.paragraphSpacingTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new border width token with updated value */
    borderWidthTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'BorderWidthTokenValue' does not satisfy the ... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.borderWidthTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new radius token with updated value */
    radiusTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'RadiusTokenValue' does not satisfy the const... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.radiusTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new duration token with updated value */
    durationTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'DurationTokenValue' does not satisfy the con... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.durationTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new z-index token with updated value */
    zIndexTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'ZIndexTokenValue' does not satisfy the const... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.zIndexTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new string token with updated value */
    stringTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'StringTokenValue' does not satisfy the const... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.stringTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new product copy token with updated value */
    productCopyTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'ProductCopyTokenValue' does not satisfy the ... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.productCopyTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new font family token with updated value */
    fontFamilyTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'FontFamilyTokenValue' does not satisfy the c... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.fontFamilyTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new font weight token with updated value */
    fontWeightTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'FontWeightTokenValue' does not satisfy the c... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.fontWeightTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new text case token with updated value */
    textCaseTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'TextCaseTokenValue' does not satisfy the con... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.textCaseTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new text case token with updated value */
    textDecorationTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'TextDecorationTokenValue' does not satisfy t... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.textDecorationTokenByUpdatingValue(token, newValue);
    }
    /** Creates a new visibility token with updated value */
    visibilityTokenByUpdatingValue(token, 
    // @ts-expect-error TS(2344): Type 'VisibilityTokenValue' does not satisfy the c... Remove this comment to see the full error message
    newValue) {
        return TokenUtils.visibilityTokenByUpdatingValue(token, newValue);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Multi-layer token manipulation
    /** Creates a new shadow token with one new extra layer added at the end of all layers */
    shadowTokenByAddingLayer(token) {
        return TokenUtils.shadowTokenByAddingLayer(token);
    }
    /** Creates a new shadow token by removing one of the layers */
    shadowTokenByRemovingLayer(token, layerIndex) {
        return TokenUtils.shadowTokenByRemovingLayer(token, layerIndex);
    }
    /** Creates a new shadow token with updated .color value. Do note, opacity is ignored */
    shadowTokenByUpdatingColor(token, layerIndex, newValue) {
        return TokenUtils.shadowTokenByUpdatingColor(token, layerIndex, newValue);
    }
    /** Creates a new shadow token with updated .color value */
    shadowTokenByUpdatingOpacity(token, layerIndex, newValue) {
        return TokenUtils.shadowTokenByUpdatingOpacity(token, layerIndex, newValue);
    }
    /** Creates a new shadow token with updated .x value */
    shadowTokenByUpdatingX(token, layerIndex, newValue) {
        return TokenUtils.shadowTokenByUpdatingX(token, layerIndex, newValue);
    }
    /** Creates a new shadow token with updated .y value */
    shadowTokenByUpdatingY(token, layerIndex, newValue) {
        return TokenUtils.shadowTokenByUpdatingY(token, layerIndex, newValue);
    }
    /** Creates a new shadow token with updated .radius value */
    shadowTokenByUpdatingRadius(token, layerIndex, newValue) {
        return TokenUtils.shadowTokenByUpdatingRadius(token, layerIndex, newValue);
    }
    /** Creates a new shadow token with updated .spread value */
    shadowTokenByUpdatingSpread(token, layerIndex, newValue) {
        return TokenUtils.shadowTokenByUpdatingSpread(token, layerIndex, newValue);
    }
    /** Creates a new shadow token with updated .type value */
    shadowTokenByUpdatingType(token, layerIndex, newValue) {
        return TokenUtils.shadowTokenByUpdatingType(token, layerIndex, newValue);
    }
    /** Creates a new gradient token with updated .to value */
    gradientTokenByUpdatingTo(token, layerIndex, newValue) {
        return TokenUtils.gradientTokenByUpdatingTo(token, layerIndex, newValue);
    }
    /** Creates a new gradient token with updated .from value */
    gradientTokenByUpdatingFrom(token, layerIndex, newValue) {
        return TokenUtils.gradientTokenByUpdatingFrom(token, layerIndex, newValue);
    }
    /** Creates a new gradient token with updated .to value */
    gradientTokenByUpdatingType(token, layerIndex, newValue) {
        return TokenUtils.gradientTokenByUpdatingType(token, layerIndex, newValue);
    }
    /** Creates a new gradient token with updated .aspectRatio value */
    gradientTokenByUpdatingAspectRatio(token, layerIndex, newValue) {
        return TokenUtils.gradientTokenByUpdatingAspectRatio(token, layerIndex, newValue);
    }
    /** Creates a new gradient token with updated .to value */
    gradientTokenByUpdatingStops(token, layerIndex, newValue) {
        return TokenUtils.gradientTokenByUpdatingStops(token, layerIndex, newValue);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Manipulating references
    /** Creates a new token where value is reference to the provided token. Token and reference must be of the same type */
    tokenByReferencing(token, reference) {
        return TokenUtils.tokenByReferencing(token, reference);
    }
    /** Creates a new multilayer token where one of the layers is reference to the provided token. Token and reference must be of the same type */
    multilayerTokenByReferencing(token, layerIndex, reference) {
        return TokenUtils.multilayerTokenByReferencing(token, layerIndex, reference);
    }
    /** Creates a new token where value is raw, but taken from the previously referenced token. Token must have had reference before */
    tokenByDisconnectingReference(token) {
        return TokenUtils.tokenByDisconnectingReference(token);
    }
    /** Creates a new multilayer token where one of the layers value is raw, but taken from the previously referenced token. That layer must have had reference before */
    multilayerTokenByDisconnectingReference(token, layerIndex) {
        return TokenUtils.multilayerTokenByDisconnectingReference(token, layerIndex);
    }
    /** Checks if token as a whole is a reference to another token */
    isReferencedToken(token) {
        return TokenUtils.isReferencedToken(token);
    }
    /** Checks if a token layer of multilayer token is a reference to another token */
    isReferencedMultilayerTokenLayer(token, layerIndex) {
        return TokenUtils.isReferencedMultilayerTokenLayer(token, layerIndex);
    }
    /** Checks if a token was imported from some foreign source. Not imported tokens were always created in Supernova */
    isTokenImported(token) {
        return TokenUtils.isTokenImported(token);
    }
}
